// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SurfCell_wrapper__11Af7","observed":"SurfCell_observed__ONRQQ","height":"SurfCell_height__iooT4"};